import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { AuthenticationContext } from "../../components/authentication/AuthenticationContext";
import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import ButtonBar from "../../components/button-bar/ButtonBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { Genre } from "../../types/Genre";
import { getGenre, postGenre } from "../../components/apis/music-api";
import callApi from "../../components/call-api/call-api";

type EditGenreProps = {
    id: string,
}

const EditGenre = () => {
    const params = useParams<EditGenreProps>();
    const navigate = useNavigate();
    const { getAccessToken } = useContext(AuthenticationContext);
    const [ genre, setGenre ] = useState<Genre>({ id: 0, name: '', description: '' });

    useEffect(() => {
        callApi<Genre>(getGenre(getAccessToken(), params.id ?? ''), setGenre);
    }, [getAccessToken, params]);
        
    const handleDescriptionChange = (description: string) => {
        if (genre !== undefined) {
            const g: Genre = { ...genre, description };
            setGenre(g);
        }
    }
    
    const save = async () => {
        await postGenre(getAccessToken(), genre);
        navigate(`/genres/${params.id}`);
    }

    const handleSave = () => {
        save();
    }

    return (
        <>
            <ButtonBar
                leftButtons={[
                    <Button component={Link} variant="contained" size="small" to={`/genres/${params.id}`}>
                        <FontAwesomeIcon fontSize="small" color="primary" icon={faBan} className="icon"/>
                        Cancel
                    </Button>
                ]}
                rightButtons={[
                    <Button variant="contained" size="small" onClick={handleSave}>
                        <FontAwesomeIcon fontSize="small" color="primary" icon={faPenToSquare} className="icon"/>
                        Save Changes
                    </Button>
                ]}
            />
            <Stack direction="row" spacing={2} sx={{ justifyContent: 'center' }}>
                <Box sx={{ width: '628px' }}>
                    <Box sx={{ mb: '20px' }}><Typography variant="h6">Create A Genre</Typography></Box>
                    <Stack spacing={3}>
                        <Box>
                            <TextField 
                                id="genre-name"
                                sx={{ width: '420px' }}
                                size="small"
                                label="Name"
                                InputLabelProps={{ shrink: true }}
                                variant="outlined" 
                                value={genre?.name}
                                onChange={(e) => setGenre({ ...genre, name: e.target.value })}
                            />
                        </Box>
                        <Box>
                            <TextField
                                id="genre-description"
                                sx={{ width: '100%', height: '220px' }}
                                maxRows={20}
                                size="small"
                                label={'Profile'}
                                InputLabelProps={{ shrink: true }}
                                variant="outlined"
                                multiline 
                                value={genre?.description}
                                onChange={(e) => handleDescriptionChange(e.target.value)}
                            />
                        </Box>
                    </Stack>
                </Box>
            </Stack>
        </>
    );
}

export default EditGenre;